export const newClientInitialValues = (values) => ({
  clientName: values?.name || "",
  pib: values?.tin || "",
  address: values?.address || "",
  phoneNumber: values?.phoneNumber || "",
  idNumber: values?.identificationNumber || "",
  contactEmail: values?.email || "",
  distributionEmails: values?.distributionEmails?.split(";") || [""],
});
